import "./LastLogin.scss"
import {default as _} from "../../../helpers/Translate"
import {Tooltip as Tooltp} from 'antd';
import { useState} from "react";
import Storage from "../../../helpers/Storage";
import T from "../../../shared/component/t/T";
import LastLoginModal from "./LastLoginModal";

const LastLogin = ({username}) => {
    const [show, setShow] = useState(false)
    
    const lastSessionText = () => {
        let last_session = Storage.getLastLogin()
        if (last_session){
            let status = last_session?.is_succeeded
            let time = Storage.getLastSessionTime()
            let lastLoginTime = `${_.datetime(time)} - ${_.datetime2time(time)}`
            let ip = Storage.getLastSessionIP()
            return <span> {_.init4(status ? 'last_succeed_login_time' : 'last_failed_login_time',
              {time: lastLoginTime, ip: ip})} </span>
        }else{
            return <T token={'no_recent_session_info'}/>
        }
    }
	
	const moreClicked = () => {
		setShow(true)
	}
    
    const text_and_more = () => {
        let textStyle = {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'center',
        }
        
        let ellipsisStyle={
            minWidth: 60,
            cursor: 'pointer',
            lineHeight: '3em'
        }
        
        
        return <span style={{...textStyle}}>
            {lastSessionText()}
            <span onClick={() => { moreClicked() }}
                  style={{...ellipsisStyle}}
                  title={_.init('more_sessions')}
            >
                <i className={'fal fa-ellipsis'}/>
            </span>
        </span>
    }
	
    
    return (<>
          <Tooltp title={() => text_and_more()}
                  overlayClassName={'last_login'}
          >
              <span className={'info__value'}>{username}</span>
          </Tooltp>
          
          {show && <LastLoginModal open={show} closeModalProp={ ()=> setShow(false) }/>}
      </>
    );
}

export default LastLogin;